export const PAGINATION_TABLE_CURRENT_PAGE_SET =
  'PAGINATION_TABLE_CURRENT_PAGE_SET';
export const PAGINATION_TABLE_INIT = 'PAGINATION_TABLE_INIT';
export const PAGINATION_TABLE_PAGE_SIZE_SET = 'PAGINATION_TABLE_PAGE_SIZE_SET';
export const PAGINATION_TABLE_TOTAL_SET = 'PAGINATION_TABLE_TOTAL_SET';



// WEBPACK FOOTER //
// ./src/components/shared/pagination/table/store/action-types.js